@if (!noData) {
  <div
    class="chart-container"
    [cpdTooltip]="matchScore"
    [tooltipDisabled]="!isShowMatchScore"
  >
    <cpd-match-score-chart [data]="occupation"></cpd-match-score-chart>
  </div>
} @else {
  <div class="chart-disabled">
    <img alt="" src="assets/images/chart/chart-disabled.png" />
  </div>
}

<ng-template #matchScore>
  @if (isShowMatchScore) {
    <div class="occupation-match-score">
      <cpd-occupation-scores-info
        [occupation]="occupation"
      ></cpd-occupation-scores-info>
    </div>
  }
</ng-template>
